<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    上芬站<br>
站点介绍<br>
上芬站位于布龙路与建设路交叉口以南，沿布龙路路中呈南北向敷设。北接元芬站，南接红山站。本站共设有4个出入口，分别为A、B、C、D出入口，B、C出入口均设有1台无障碍垂直电梯。站厅A端设置公共卫生间（含第三卫生间），车站站厅设1个客服中心，站台为岛式站台。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:21	23:47	6号线	3分24秒	6分20秒<br>
松岗	06:03	23:23	6号线	3分24秒	6分20秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:28	23:47	6号线	4分45秒	6分钟<br>
松岗	06:09	23:23	6号线	4分45秒	6分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
科学馆	06:28	00:47	6号线	4分45秒	6分钟<br>
松岗	06:09	00:23	6号线	4分45秒	6分钟<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
龙屋工业区,源创园玖号,深圳誉成汽车销售服务有限公司,布龙路南侧<br><br>
B出入口:<br>
西头新村,布龙路南侧<br><br>
C出入口:<br>
鸿荣源.尚峻,龙胜恒博中心,布龙路北侧，华东师范大学附属深圳龙华学校<br><br>
D出入口:<br>
御龙华庭，深圳市未来小学,中海锦城,布龙路北侧<br><br>
公交换乘信息<br><br>
B出入口:<br>
公交站名：<br>
M301路,M341路,M415路,M420路,M462路,M580路,高峰专线92<br><br>
D出入口:<br>
公交站名：<br>
M156路,M264路,M301路,M341路,M415路,M420路,M462路,M580路,高峰专线92<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "liuhaoxian",
          title: "6号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>